import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apiService from '../services/api'

const RequireAdmin = ({ children }) => {
  const [checking, setChecking] = useState(true)
  const [allowed, setAllowed] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem('user_token') || localStorage.getItem('admin_token')
    if (!token) {
      setAllowed(false)
      setChecking(false)
      navigate('/admin/login')
      return
    }
    apiService.get('/auth/me')
      .then((res) => {
        const user = res.data?.user || res.data?.admin || null
        const isAdmin = user?.role === 'admin'
        setAllowed(Boolean(isAdmin))
        setChecking(false)
        if (!isAdmin) navigate('/admin/login')
      })
      .catch(() => {
        setAllowed(false)
        setChecking(false)
        navigate('/admin/login')
      })
  }, [navigate])

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center text-gray-600">Vérification des droits…</div>
      </div>
    )
  }

  if (!allowed) return null

  return children
}

export default RequireAdmin


